import { Box, Skeleton, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/system";
import { ChevronRight } from "@pmag/icons";
import type * as React from "react";

import { Card, RightContainer, RowContainer } from "./CategoryCard.styles";

export const CategoryCardSkeleton: React.FunctionComponent = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    if (isSmallScreen) {
        return (
            <RowContainer>
                <Skeleton height={20} width={100} />

                <RightContainer>
                    <Skeleton height={15} width={60} />

                    <ChevronRight color={theme.palette.core.grey._40} />
                </RightContainer>
            </RowContainer>
        );
    }

    return (
        <Card>
            <Box>
                <Box mb={2}>
                    <Skeleton height={28} width={140} />
                </Box>

                <Skeleton height={24} width={80} />
            </Box>

            <ChevronRight color={theme.palette.core.grey._60} />
        </Card>
    );
};
